'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useSuspensions, useValidators } from '@personly/libs-providers';
import { Textarea } from '@personly/libs-widgets';
import { useTextareas } from '@/providers/textareas';
interface Props {
  id: string;
}
const TicketTextarea = t0 => {
  const $ = _c(8);
  const {
    id
  } = t0;
  const {
    textarea,
    setTextarea
  } = useTextareas();
  const {
    suspended
  } = useSuspensions();
  const {
    validate
  } = useValidators();
  const blocked = suspended("CREATE_TICKET") === "STARTED";
  const t1 = textarea.length > 0 && !validate("BODY", textarea);
  let t2;
  if ($[0] !== setTextarea) {
    t2 = e => setTextarea(e.target.value);
    $[0] = setTextarea;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== blocked || $[3] !== id || $[4] !== t1 || $[5] !== t2 || $[6] !== textarea) {
    t3 = <Textarea invalid={t1} id={id} value={textarea} onChange={t2} disabled={blocked} rows={10} />;
    $[2] = blocked;
    $[3] = id;
    $[4] = t1;
    $[5] = t2;
    $[6] = textarea;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default TicketTextarea;